<template>
  <IconWrapper v-if="filled" name="add-calendar" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4744 4.085C17.6944 4.195 18.7244 4.605 19.4544 5.325C20.2644 6.135 20.6844 7.315 20.6844 8.725V9.325C20.6844 9.43546 20.5949 9.525 20.4844 9.525H3.68438C3.57392 9.525 3.48438 9.43546 3.48438 9.325V8.725C3.48438 6.43211 4.58885 4.88473 6.49756 4.31245C6.622 4.27513 6.74437 4.37063 6.74437 4.50055V5.965C6.74437 6.375 7.08438 6.715 7.49438 6.715C7.56438 6.715 7.63438 6.695 7.69438 6.675V3.125C7.69438 2.715 8.03438 2.375 8.44438 2.375C8.86438 2.375 9.19438 2.715 9.19438 3.125V4.045H13.8244C13.9349 4.045 14.0244 4.13454 14.0244 4.245V5.965C14.0244 6.375 14.3544 6.715 14.7744 6.715C14.8365 6.715 14.8908 6.69925 14.9511 6.68172C14.9588 6.6795 14.9665 6.67725 14.9744 6.675V3.125C14.9744 2.715 15.3044 2.375 15.7244 2.375C16.1344 2.375 16.4744 2.715 16.4744 3.125V4.085Z"
        fill="#1B1B1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.27437 21.6254C5.27437 21.6254 3.48438 19.8454 3.48438 16.8654V11.2254C3.48438 11.1149 3.57392 11.0254 3.68438 11.0254H20.4844C20.5949 11.0254 20.6844 11.1149 20.6844 11.2254V16.9354C20.6844 19.8754 18.8944 21.6254 15.8944 21.6254H8.27437ZM11.3344 15.4714H9.83438C9.42038 15.4714 9.08438 15.8074 9.08438 16.2214C9.08438 16.6354 9.42038 16.9714 9.83438 16.9714H11.3344V18.4714C11.3344 18.8854 11.6704 19.2214 12.0844 19.2214C12.4984 19.2214 12.8344 18.8854 12.8344 18.4714V16.9714H14.3344C14.7484 16.9714 15.0844 16.6354 15.0844 16.2214C15.0844 15.8074 14.7484 15.4714 14.3344 15.4714H12.8344V13.9714C12.8344 13.5574 12.4984 13.2214 12.0844 13.2214C11.6704 13.2214 11.3344 13.5574 11.3344 13.9714V15.4714Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="add-calendar" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.4873 9.66406H20.5288"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M16.1426 3V5.96174" stroke="#1B1B1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.87207 3V5.96174" stroke="#1B1B1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3184 4.42188H8.69804C6.05446 4.42188 4.4043 5.89399 4.4043 8.59984V16.7456C4.4043 19.4943 6.05446 21.0004 8.69804 21.0004H16.3106C18.962 21.0004 20.6044 19.5205 20.6044 16.8137V8.59984C20.6121 5.89399 18.9698 4.42188 16.3184 4.42188Z"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5039 12.8262V17.3263"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7529 15.0762H10.2529"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
